import { useEffect, useState, useCallback, useMemo } from "react";

import MODALS from "../../../constants/modals";

import { useAppDispatch } from "../../../hooks/redux";
import { openModal } from "../../../features/modals";
import axios from "axios";

import { Stack, Grid, Typography, Button } from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import { IChairResponse } from "../../../types/classifiers";
import PermissionGuard from "../../../components/PermissionGuard";
import PERMISSIONS from "../../../constants/permissions";
import { MaterialReactTable, MRT_ColumnDef } from "material-react-table";
import _ from "lodash";
import { ClinicResponse } from "../../../types/clinic";

const Chairs: React.FC = () => {
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState(true);
  const [response, setResponse] = useState<IChairResponse[]>();

  const [clinics, setClinics] = useState<ClinicResponse[]>([]);

  const columns = useMemo<MRT_ColumnDef<IChairResponse>[]>(
    () => [
      {
        accessorKey: "name",
        header: "Nosaukums",
      },
      {
        accessorKey: "clinic",
        header: "Klīnika",
        Cell(props) {
          return props.row.original.clinic.name;
        },
        filterSelectOptions: clinics.map((clinic) => ({
          text: clinic.name,
          value: clinic._id,
        })),
        accessorFn: (row) => row.clinic._id,
        filterVariant: "select",
      },
    ],
    [clinics]
  );

  const loadData = useCallback(() => {
    setIsLoading(true);
    axios
      .get<IChairResponse[]>("/classifiers/chairs/list")
      .then((res) => {
        setResponse(res.data);
      })
      .catch((err) => {
        console.log("error:", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  useEffect(() => {
    axios
      .get<ClinicResponse[]>("/clinics")
      .then((res) => {
        setClinics(res.data);
      })
      .catch((err) => {
        console.log("err:", err);
      });
  }, []);

  return (
    <Stack spacing={2}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h4">Krēsli</Typography>
        </Grid>
        <PermissionGuard permission={PERMISSIONS.WRITE_LABORATORIES}>
          {({ hasAccess }) => (
            <>
              {hasAccess ? (
                <Grid item>
                  <Button
                    startIcon={<AddIcon />}
                    onClick={() => {
                      dispatch(
                        openModal({
                          type: MODALS.Chair,
                          callback: () => loadData(),
                        })
                      );
                    }}
                  >
                    Pievienot
                  </Button>
                </Grid>
              ) : null}
            </>
          )}
        </PermissionGuard>
      </Grid>
      <MaterialReactTable
        columns={columns}
        enableColumnActions={false}
        data={response ?? []}
        getRowId={(row) => row._id}
        initialState={{
          sorting: [
            {
              id: "clinic",
              desc: false,
            },
          ],
        }}
        state={{
          isLoading,
        }}
        muiTableBodyRowProps={(props) => ({
          onClick: () => {
            dispatch(
              openModal({
                type: MODALS.Chair,
                initialValues: props.row.original,
                callback: () => loadData(),
              })
            );
          },
          style: { cursor: "pointer" },
        })}
      />
    </Stack>
  );
};

export default Chairs;
